// noinspection DuplicatedCode

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { fetchGet, fetchPost, fetchPut } from "../../../fetchers";
import { useMutation } from "@tanstack/react-query";
import { BiArrowBack } from "react-icons/bi";
import { useForm } from "../../../components/isRequired";

import "react-datepicker/dist/react-datepicker.css";

import Loading from "../../../components/loading/Loading";
import { getOtoritas, updateOtoritas, OtoritasSlice } from "./OtoritasSlice";

import { Colors } from "../../../assets/Colors";

function isRequired(value) {
  let status = false;
  if (value !== null) {
    if (typeof value === "number") {
      if (value !== -1) {
        status = true;
      }
    }
  }
  return status;
}

// function useForm(initialState = {}, validations = [], onSubmit = () => {}) {
//   const { isValid: initialIsValid, errors: initialErrors } = validate(
//     validations,
//     initialState
//   );

//   const [changed, setChanged] = useState(false);
//   const [values, setValues] = useState(initialState);
//   const [errors, setErrors] = useState(initialErrors);
//   const [isValid, setValid] = useState(initialIsValid);
//   const [touched, setTouched] = useState({});

//   const changeHandlerActivity = (data) => {
//     const { isValid, errors } = validate(validations, data);
//     setChanged(true);
//     setValues(data);
//     setValid(isValid);
//     setErrors(errors);
//   };

//   const editHandler = (initValues) => {
//     const newValues = {
//       ...values,
//       data: initValues.data,
//     };
//     setValues(newValues);
//   };

//   const clearHandler = () => {
//     setValues(initialState);
//   };

//   const submitHandler = (event) => {
//     event.preventDefault();
//     onSubmit(values);
//   };
//   return {
//     values,
//     editHandler,
//     clearHandler,
//     isValid,
//     errors,
//     touched,
//     changeHandlerActivity,
//   };
// }

function validate(validations, values) {
  const errors = validations
    .map((validation) => validation(values))
    .filter((validation) => typeof validation === "object");
  return {
    isValid: errors.length === 0,
    errors: errors.reduce((errors, error) => ({ ...errors, ...error }), {}),
  };
}

const OtoritasPage = ({}) => {
  const otorityarray = [
    { name: "Account_Payable", value: "Account Payable" },
    { name: "Additional_Quotation", value: "Additional Quotation" },
    { name: "Allocation", value: "Allocation" },
    { name: "Buku_Bank_HO", value: "Buku Bank HO" },
    { name: "Buku_Bank_SO", value: "Buku Bank SO" },
    { name: "Buku_Besar", value: "Buku Besar" },
    { name: "Buku_Kas_HO", value: "Buku Kas HO" },
    { name: "Buku_Kas_SO", value: "Buku Kas SO" },
    { name: "CashJournal", value: "Cash Journal" },
    { name: "Closing", value: "Closing" },
    { name: "GoodsAcceptance", value: "Goods Acceptance" },
    { name: "GoodsExpenditure", value: "Goods Expenditure" },
    { name: "GoodsStock", value: "Goods Stock" },
    { name: "GoodsStockBagian", value: "Goods Stock (Bagian Saya)" },
    { name: "POTransit", value: "PO Transit" },
    { name: "GoodsPenerimaan", value: "Goods Penerimaan" },
    { name: "GoodsLapPenerimaan", value: "Goods Lap Penerimaan" },
    { name: "GoodsPengeluaran", value: "Goods Pengeluaran" },
    { name: "GoodsLapPengeluaran", value: "Goods Lap Pengeluaran" },
    { name: "GoodsReturn", value: "Goods Return" },

    { name: "Invoice_Job_Request", value: "Invoice Job Request" },
    { name: "Jurnal", value: "Jurnal" },
    { name: "Laba_Rugi", value: "Laba Rugi" },

    { name: "MActivity", value: "Master Activity" },
    { name: "MAreaRental", value: "Master Area Rental" },
    { name: "MBagian", value: "Master Bagian" },
    { name: "MBank", value: "Master Bank" },
    { name: "MBarang", value: "Master Barang" },
    { name: "MBisnisUnit", value: "Master BisnisUnit" },
    { name: "MCargoCarryingUnit", value: "Master Cargo Carrying Unit" },
    { name: "MCustomer", value: "Master Customer" },
    { name: "MCuti", value: "Master Cuti" },
    { name: "MDestination", value: "Master Destination" },
    { name: "MDesa", value: "Master Desa" },

    { name: "MDetailAccount", value: "Master Detail Account" },
    { name: "MFranco", value: "Master Franco" },
    { name: "MFuel", value: "Master Fuel" },
    { name: "MGeneralServiceUnit", value: "Master General Service Unit" },
    { name: "MGolongan", value: "Master Golongan" },
    { name: "MGudang", value: "Master Gudang" },
    { name: "MHolidays", value: "Master Hari Libur" },
    { name: "MJabatan", value: "Master Jabatan" },
    { name: "MJetty", value: "Master Jetty" },
    { name: "MKaryawan", value: "Master Karyawan" },
    { name: "MLKaryawan", value: "Laporan Karyawan" },

    { name: "TLCuti", value: "Laporan Cuti" },
    { name: "TLIzin", value: "Laporan Izin" },
    { name: "TLSakit", value: "Laporan Sakit" },
    { name: "TLPelatihan", value: "Laporan Pelatihan" },
    { name: "TLTiket", value: "Laporan Tiket" },
    { name: "TLLembur", value: "Laporan Lembur" },
    { name: "TLPengobatan", value: "Laporan Pengobatan" },
    { name: "TLPhk", value: "Laporan PHK" },
    { name: "MLFKaryawan", value: "Laporan File Karyawan" },
    { name: "TCSR", value: "CSR" },

    { name: "MKegiatan", value: "Master Kegiatan" },
    { name: "MKelompok", value: "Master Kelompok" },
    { name: "MKelompokKegiatan", value: "Master Kelompok Kegiatan" },
    { name: "MKemasan", value: "Master Type Of Packaging" },
    { name: "MKendaraan", value: "Master Kendaraan" },

    { name: "MKlien", value: "Master Klien" },
    { name: "MKota", value: "Master Kota" },
    { name: "MLabour", value: "Master Manpower" },
    { name: "MLimbah", value: "Master Haz Waste" },
    { name: "MLocationUsed", value: "Master Location Used" }, // takda
    { name: "MLokasiTugas", value: "Master Lokasi Tugas" },
    { name: "MMainAccount", value: "Master Main Account" },
    { name: "MMeals", value: "Master Meals" },
    { name: "MNegara", value: "Master Negara" },
    { name: "MOum", value: "Master Oum" },
    { name: "MPenyakit", value: "Master Penyakit" },
    { name: "MProvinsi", value: "Master Provinsi" },
    { name: "MRental", value: "Master Rental" },
    { name: "MRentalUnit", value: "Master Rental Unit" },
    { name: "MRoom", value: "Master Room" },
    { name: "MSatuan", value: "Master Satuan" },
    { name: "MStrukturOrganisasi", value: "Master Struktur Organisasi" },
    { name: "MSubAccount", value: "Master Sub Account" },
    { name: "MSubGroupAccount", value: "Master Sub Group Account" },
    { name: "MSubKegiatan", value: "Master Sub Kegiatan" },
    { name: "MSupplier", value: "Master Supplier" },
    { name: "MTim", value: "Master Tim" },
    { name: "MTipeKaryawan", value: "Master Tipe Karyawan" },
    { name: "MTypeOfClothing", value: "Master Type Of Clothing" },
    { name: "MWasteManagement", value: "Master Waste Management" },
    { name: "MPayroll", value: "Master Payroll" },
    { name: "MPayrollHO", value: "Master Payroll HO" },
    {
      name: "MonitoringPurchaseRequisition",
      value: "Monitoring MSR",
    },
    { name: "Monitoring_Jurnal", value: "Monitoring Jurnal" },
    {
      name: "Monitoring_Pembayaran_Non_PO",
      value: "Monitoring Pengajuan Pembayaran",
    },
    { name: "Monitoring_Pembayaran_PO", value: "Monitoring Pembayaran AP" },
    { name: "Monitoring_Penerimaan_Dana", value: "Monitoring Penerimaan Dana" },
    { name: "Monitoring_Quotation", value: "Monitoring Quotation" },

    { name: "MonitoringPriceComparison", value: "Monitoring Price Comparison" },
    { name: "MonitoringPurchraseOrder", value: "Monitoring Purchase Order" },

    { name: "Neraca", value: "Neraca" },
    { name: "OrderWarehouse", value: "Purchase Order" },
    // "PembayaranAP" dihapus dari daftar: permission yatim, tak dibaca menu/sidebar
    // mana pun (gerbang menu Pembayaran AP = "Permohonan_Pembayaran_PO").
    // Kolom SOtoritas."PembayaranAP" sengaja dibiarkan ada; nilainya lewat apa
    // adanya saat simpan karena values.data berasal dari respons backend.
    { name: "PenerimaanKas", value: "Penerimaan Kas" },
    { name: "Penerimaan_Dana", value: "Penerimaan Dana" },
    { name: "Penerimaan_Kas_HO", value: "Penerimaan Kas HO" },
    { name: "Penerimaan_Kas_SO", value: "Penerimaan Kas SO" },
    { name: "Pengeluaran_Kas_HO", value: "Pengeluaran Kas HO" },
    { name: "Pengeluaran_Kas_SO", value: "Pengeluaran Kas SO" },
    {
      name: "Permohonan_Pembayaran_Non_PO",
      value: "Pengajuan Pembayaran",
    },
    { name: "Permohonan_Pembayaran_PO", value: "Permohonan Pembayaran AP" },
    { name: "PriceComparison", value: "Price Comparison" },
    { name: "PurchaseRequisition", value: "MSR" },
    { name: "Quotation", value: "Quotation" },
    { name: "SApproval", value: "Setup Approval" },
    { name: "SApprovalPC", value: "Setup Approval PC" },
    { name: "SAuth", value: "Setup Otorisasi" },
    { name: "SCuti", value: "Setup Cuti" },
    { name: "SJamKerja", value: "Setup JamKerja" },
    { name: "SLembur", value: "Setup Lembur" },
    { name: "SPlafonPerobatan", value: "Setup Plafon Perobatan" },
    { name: "SSpecimen", value: "Setup Specimen" },
    { name: "SSaldoAwal", value: "Setup Saldo Awal" },

    { name: "TActivity", value: "Transaksi Activity" },

    { name: "TCuti", value: "Transaksi Cuti" },
    { name: "EntryCuti", value: "Entry Cuti (Admin Divisi)" },
    { name: "THrdMonitoring", value: "Transaksi Hrd Monitoring" },
    { name: "TIzin", value: "Transaksi Izin" },
    { name: "TJobRequest", value: "Transaksi Job Request" },
    { name: "TLJobRequest", value: "Laporan Job Request" },

    { name: "TKendaraan", value: "Transaksi Kendaraan" },
    { name: "TMKendaraan", value: "Transaksi Monitoring Kendaraan" },
    { name: "TRKendaraan", value: "Transaksi Report Kendaraan" },

    { name: "TLembur", value: "Transaksi Lembur" },
    {
      name: "TOperationalMonitoring",
      value: "Transaksi Operational Monitoring",
    },
    { name: "TPelatihan", value: "Transaksi Pelatihan" },
    { name: "TPengobatan", value: "Transaksi Pengobatan" },
    { name: "TPermintaanUnit", value: "Transaksi Permintaan Unit" },
    { name: "TPermit", value: "Transaksi Permit" },
    { name: "TPhk", value: "Transaksi Phk" },
    { name: "TPromosi", value: "Transaksi Promosi" },
    { name: "TKontrakKerja", value: "Transaksi Kontrak Kerja" },
    { name: "TPerjalananDinas", value: "Transaksi Perjalanan Dinas" },
    { name: "TMonitoringLPD", value: "Transaksi Monitoring LPD Dinas" },
    { name: "MTarifUangSaku", value: "Master Tarif Uang Saku" },
    { name: "TResign", value: "Transaksi Resign" },
    { name: "TSakit", value: "Transaksi Sakit" },
    { name: "TService", value: "Transaksi Service" },
    { name: "TShippingManifest", value: "Transaksi Shipping Manifest" },
    { name: "TTiket", value: "Transaksi Tiket" },
    { name: "Trial_Balance", value: "Trial Balance" },
    { name: "UserPC", value: "User PC" },
    { name: "LaporanPurchaseOrder", value: "Laporan Purchase Order" },

    { name: "Payroll", value: "Payroll" },
    { name: "MEquipment", value: "MEquipment" },
    { name: "AdjustmentStock", value: "AdjustmentStock" },
    { name: "GoodsAccepteanceUser", value: "GoodsAccepteanceUser" },
    { name: "MemoInternal", value: "MemoInternal" },
    { name: "MemoInternalReport", value: "MemoInternalReport" },
     // Menu baru yang ditambahkan
    { name: "MemoInternalAll", value: "Internal Memo All" },
    { name: "MemoInternalReportAll", value: "Memo Report All" },
    { name: "AbsensiKaryawan", value: "	Absensi Karyawan" },
    { name: "JamKerja", value: "Jadwal Kerja" },
    { name: "MonitoringInvoiceQuatation", value: "Monitoring Invoice Quatation" },
    { name: "DashboardAnalisa", value: "Dashboard Analisa" },
    { name: "AbsensiWajah", value: "Absensi Wajah (Face Recognition)" },
    { name: "KioskDevice", value: "Device Absensi Wajah (Kiosk)" },
  ];

  const validations = [];

  let initialState = {
    data: [],
  };

  // const { values, errors, touched, editHandler, changeHandlerActivity } =
  //   useForm(initialState, validations);

  const {
    changed,
    values,
    isValid,
    touched,
    submitHandler,
    customHandler,
    changeHandler,
    errors,
    blastChange,
    editHandler,
  } = useForm(initialState, validations);
  const [buttonTouched, setButtonTouched] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [firstLoading, setFirstLoading] = useState(false);
  const [term, setterm] = useState("");

  const param = useParams();

  const user = useSelector(OtoritasSlice);
  const mutationGet = useMutation((formData) =>
    fetchGet("getOtoritas/" + formData)
  );

  useEffect(() => {
    mutationGet.mutate(param.id);
  }, []);

  useEffect(() => {
    if (mutationGet.data) {
      let tempData = mutationGet.data;
      blastChange(tempData);

      setFirstLoading(true);
    }
  }, [mutationGet.status]);

  // useEffect(() => {
  //   setFirstLoading(false);
  //   dispatch(getOtoritas({ Username: param.id }));
  // }, []);

  // useEffect(() => {
  //   if (user.isotoritasSuccess && !firstLoading && !user?.isotoritasFetching) {
  //     blastChange(user.otoritasData);
  //     const initValues = {
  //       data: user,
  //     };
  //     editHandler(initValues);

  //     setFirstLoading(true);
  //   }
  // });

  function handleInsertJR() {
    let sendArray = {
      ...values.data,
      Username: param.id,
    };

    dispatch(updateOtoritas(sendArray));
  }

  if (!firstLoading) {
    return <Loading />;
  } else {
    return (
      <>
        <div className="md:ml-64">
          <div className="w-full flex flex-col items-center">
            <div className="w-full px-4 my-4 ">
              <div
                style={{ borderColor: Colors.primary }}
                className="flex flex-col border rounded"
              >
                <div className="flex w-full justify-end p-4 flex-col sm:flex-row pt-4">
                  <button
                    onClick={() => navigate("/setup-user")}
                    className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 shadow rounded"
                  >
                    <BiArrowBack className="text-xl text-gray-800 pr-2" />
                    Kembali
                  </button>
                  {parseInt(values.Status) > 103 ? (
                    <></>
                  ) : (
                    <button
                      onClick={() => handleInsertJR()}
                      className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 shadow rounded"
                    >
                      Simpan
                    </button>
                  )}
                </div>
                <div className="flex flex-row">
                  <div className="px-4 py-4 flex-1">
                    <div className="flex flex-wrap -mx-3">
                      <div className="w-full px-3 mb-1 md:mb-0">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                          Username
                        </label>
                        <div className="inline-block relative w-full">
                          <input
                            disabled
                            value={param.id}
                            name="Username"
                            className={
                              "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                            }
                            type="text"
                          />
                        </div>
                        {(touched.QuatationNo || buttonTouched) &&
                          errors.QuatationNo && (
                            <p className="text-red-500 text-xs italic">
                              {errors.QuatationNo}
                            </p>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="p-4">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Otoritas
                  </label>
                  <div className="flex flex-row flex-wrap items-start justify-start w-full px-2">
                    <div className="flex items-center justify-start py-2 mx-2 rounded">
                      <div
                        className="relative text-gray-800 border rounded-md"
                        style={{ color: Colors.primary }}
                      >
                        <span className="absolute inset-y-0 left-0 flex items-center pl-2">
                          <button
                            type="submit"
                            className="p-1 focus:outline-none focus:shadow-outline"
                          >
                            <svg
                              fill="none"
                              stroke="currentColor"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              viewBox="0 0 24 24"
                              className="w-6 h-6"
                            >
                              <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                            </svg>
                          </button>
                        </span>
                        <input
                          onChange={(e) => {
                            setterm(e.target.value);
                          }}
                          value={term}
                          className="py-2 text-sm text-gray-800 rounded-md pl-10 pr-2 bg-white focus:outline-none"
                          placeholder={"Cari Auth"}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-row flex-wrap items-start justify-start w-full px-2 ">
                    {otorityarray
                      .filter(
                        (item) =>
                          item["value"]
                            .toLowerCase()
                            .indexOf(term.toLowerCase()) > -1
                      )
                      .map((x, index) => {
                        return (
                          <div className="w-1/3 cursor-pointer">
                            <div
                              style={{
                                borderColor: Colors.primary,
                              }}
                              className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                            >
                              <div className="inline-block relative w-full">
                                <p className="pl-2">{x["value"]}</p>
                              </div>
                              <div className="inline-block relative w-full">
                                <div className="w-full px-3">
                                  <input
                                    checked={values.data[x["name"]] === 0}
                                    type="radio"
                                    id={`custom-checkbox-${index}`}
                                    name={x["name"]}
                                    value={0}
                                    onChange={(e) => {
                                      let tempdata = JSON.parse(
                                        JSON.stringify(values)
                                      );
                                      tempdata.data[x["name"]] = 0;
                                      editHandler(tempdata);
                                    }}
                                    className="mr-2"
                                  />
                                  <label htmlFor={`custom-checkbox-${index}`}>
                                    No Access
                                  </label>
                                </div>
                                <div className="w-full px-3">
                                  <input
                                    checked={values.data[x["name"]] === 1}
                                    type="radio"
                                    id={`custom-checkbox-${index}`}
                                    name={index}
                                    value={1}
                                    onChange={(e) => {
                                      let tempdata = JSON.parse(
                                        JSON.stringify(values)
                                      );
                                      tempdata.data[x["name"]] = 1;
                                      editHandler(tempdata);
                                    }}
                                    className="mr-2"
                                  />
                                  <label htmlFor={`custom-checkbox-${index}`}>
                                    Read
                                  </label>
                                </div>
                                <div className="w-full px-3">
                                  <input
                                    checked={values.data[x["name"]] === 2}
                                    type="radio"
                                    id={`custom-checkbox-${index}`}
                                    name={index}
                                    value={2}
                                    onChange={(e) => {
                                      let tempdata = JSON.parse(
                                        JSON.stringify(values)
                                      );
                                      tempdata.data[x["name"]] = 2;
                                      editHandler(tempdata);
                                    }}
                                    className="mr-2"
                                  />
                                  <label htmlFor={`custom-checkbox-${index}`}>
                                    Add/Edit
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
};

export default OtoritasPage;
